module.exports = __webpack_public_path__ + "img/features_bg.f62fec1e.svg";